<template>
  <WdsText class="tw-text-right" size="sm">
    {{ formattedUnits }}
  </WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestUnitsColumnClient = graphql(`
  fragment PaymentRequestUnitsColumnClient on PaymentRequest {
    id
    rateType
    rateQuantity
    billedAmount
  }
`)

const props = defineProps<{ row: FragmentType<typeof PaymentRequestUnitsColumnClient> }>()
const column = computed(() => useFragment(PaymentRequestUnitsColumnClient, props.row))

const isTimeBased = computed(() => {
  const rateType = column.value.rateType?.toLowerCase()
  return ['hourly', 'daily', 'weekly', 'monthly'].includes(rateType || '')
})

const hasBilledAmount = computed(() => column.value.billedAmount > 0)

const formattedUnits = computed(() => {
  if (!isTimeBased.value || !hasBilledAmount.value) {
    return '-'
  }
  const quantity = column.value.rateQuantity
  return quantity ? quantity.toLocaleString() : '-'
})
</script>

